import React, { createContext, useState, useContext, ReactNode } from 'react';

interface AdminContextType {
  avatarUrl: string | null;
  setAvatarUrl: (url: string | null) => void;
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

export const AdminProvider = ({ children }: { children: ReactNode }) => {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);

  return (
    <AdminContext.Provider value={{ avatarUrl, setAvatarUrl }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdminContext = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdminContext must be used within an AdminProvider');
  }
  return context;
};